<script>
import ModalDialog from '../UI/Modal/ModalDialog.vue'
import ButtonAll from '../UI/Button/ButtonAll.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'

export default {
  components: { ButtonAll, ModalDialog },
  mixins: [mixinComponent, globalVariablesMixin],

  data: function () {
    return {
      email: '',
      password: '',
      password2: '',
      code: '',
      step: 'email',
      error: '',
      message: 'security.password.message.email',
      pattern: '',
      loading: false,
      ref: 'changePasswordModal',
    }
  },

  methods: {
    initModal() {
      this.$refs.modal.open()
      this.email = ''
      this.password = ''
      this.password2 = ''
      this.code = ''
      this.step = 'email'
      this.error = ''
      this.message = 'security.password.message.email'
      this.pattern = ''
    },
    sendEmail() {
      this.loading = true
      let content = { username: this.email }
      this.postJSON('users/passwords', content).then((json) => {
        this.step = 'code'
        this.message = 'security.password.message.code'
        this.loading = false
      }, this.handleError)
    },

    sendCode() {
      this.loading = true
      let content = { username: this.email, token: this.code }
      this.error = ''

      this.postJSON('users/passwords/confirms', content).then((json) => {
        this.step = 'password'
        this.message = 'security.password.message.password'
        this.pattern = json.passwordPattern
        this.loading = false
      }, this.handleError)
    },

    sendPassword() {
      this.loading = true
      this.error = ''

      // verif du mot de passe
      if (this.password !== this.password2) {
        this.error = 'not_same'
        return
      }
      if (this.password.match(this.pattern) != null) {
        this.error = 'bad_pattern'
        return
      }

      let content = { plainPassword: { first: this.password, second: this.password2 } }
      this.postJSON('users/' + this.email + '/passwords/' + this.code + '/resets', content).then((json) => {
        this.step = 'end'
        this.message = 'security.password.message.success'
        this.loading = false
      }, this.handleError)
    },
    handleError(reason) {
      if (reason.statusCode === 429) {
        this.error = 'too_many_password_reset_attempts'
      } else {
        this.error = reason.getResponseErrorsMessage()
      }
    },
  },
}
</script>
<template>
  <ModalDialog ref="modal" id="modal-change-password" title-t="security.password.title" e2e-modal="changePassword">
    <template #body>
      <span v-if="message"
        ><b>{{ $t(message) }}</b></span
      >
      <br /><br />
      <div v-if="error" class="alert alert-danger">{{ $t('security.error.' + error) }}</div>
      <input
        class="form-control form-control-lg"
        v-model="email"
        v-if="step === 'email'"
        :placeholder="$t('security.password.email')"
        e2e-input="email"
      />
      <input
        id="code"
        class="form-control"
        v-model="code"
        v-if="step === 'code'"
        :placeholder="$t('security.password.code')"
        e2e-input="code"
      />
      <input
        id="password"
        class="form-control"
        type="password"
        v-model="password"
        v-if="step === 'password'"
        :placeholder="$t('security.password.password')"
        e2e-input="password"
      />
      <input
        id="password2"
        class="form-control"
        type="password"
        v-model="password2"
        v-if="step === 'password'"
        :placeholder="$t('security.password.password2')"
        e2e-input="password2"
      />
    </template>
    <template #footer>
      <ButtonAll
        v-if="step === 'email'"
        margin="no"
        :loading="loading"
        label="security.password.sendEmail"
        type="success"
        @click="sendEmail"
        name="sendEmail"
      />
      <ButtonAll
        v-if="step === 'code'"
        margin="no"
        :loading="loading"
        label="security.password.sendCode"
        type="success"
        @click="sendCode"
        name="sendCode"
      />
      <ButtonAll
        v-if="step === 'password'"
        margin="no"
        :loading="loading"
        label="security.password.sendPassword"
        type="success"
        @click="sendPassword"
        name="sendPassword"
      />
    </template>
  </ModalDialog>
</template>
